export const getSyrahFranceData = () => ({
  name: "Syrah",
  country: "France",
  description: "La Syrah est principalement cultivée dans la vallée du Rhône, produisant des vins rouges puissants et épicés.",
  regions: [
    { name: "Côte-Rôtie", area: "2,500 ha", percentage: "30%", description: "Grands crus du nord" },
    { name: "Hermitage", area: "2,000 ha", percentage: "24%", description: "Vins de garde" },
    { name: "Côtes du Rhône", area: "1,800 ha", percentage: "22%", description: "Vins d'assemblage" },
    { name: "Châteauneuf-du-Pape", area: "1,200 ha", percentage: "14%", description: "Usage limité" },
    { name: "Autres", area: "800 ha", percentage: "10%", description: "Dispersé dans le Rhône" }
  ],
  mapAreas: [
    { region: "Côte-Rôtie", x: 60, y: 45, color: "#4B164C", size: 6 },
    { region: "Hermitage", x: 59, y: 48, color: "#6d2c7a", size: 5 },
    { region: "Côtes du Rhône", x: 58, y: 55, color: "#8a4a8a", size: 4 },
    { region: "Châteauneuf-du-Pape", x: 57, y: 60, color: "#a768a6", size: 3 }
  ],
  subregions: {
    rhone: {
      name: "Rhône",
      description: "La Syrah du Rhône produit des vins rouges puissants et épicés, avec une personnalité unique.",
      characteristics: {
        aromas: "Fruits noirs, poivre noir, olive, notes de garrigue",
        body: "Corps plein et puissant",
        tannins: "Tannins fermes et structurés",
        aging: "Excellent potentiel (10-20 ans)"
      },
      terroir: {
        climate: "Climat méditerranéen",
        soil: "Sols granitiques et galets roulés",
        viticulture: "Rendements limités, vendanges manuelles"
      },
      differentiators: [
        "Puissance et concentration uniques",
        "Notes de poivre noir caractéristiques",
        "Complexité aromatique développée",
        "Style robuste et authentique"
      ],
      foodPairing: "Viandes rouges, gibier, fromages affinés, plats épicés"
    }
  }
}); 